import React from 'react';
import { FaFacebook, FaGithub, FaInstagram, FaLinkedin, FaYoutube } from 'react-icons/fa';
import "./footer.css";
const Footer = () => {
  return (
    <div className='footer'>
        <div className="footer-container">
            <h5 className="copy-right">&copy;Habib All Right Reserve</h5>
            <div className="social-icon">
              <a href="https://www.facebook.com/habibrayhan.07" target="_blank"><FaFacebook size={20} style={{ color:"#fff", marginRight:"2rem"}}/></a>
              <a href="https://www.linkedin.com/in/habibrayhan007/" target="_blank"><FaLinkedin size={20} style={{ color:"#fff", marginRight:"2rem"}}/></a>
              <a href="https://github.com/habibrayhan007" target="_blank"><FaGithub size={20} style={{ color:"#fff", marginRight:"2rem"}}/></a>
              <a href="https://www.instagram.com/habibrayhan007/" target="_blank"><FaInstagram size={20} style={{ color:"#fff", marginRight:"2rem"}}/></a>
              <a href="https://www.youtube.com/channel/UCPS-rFhcjcS8BoTGoDhAiPw" target="_blank"><FaYoutube size={20} style={{ color:"#fff", marginRight:"2rem"}}/></a>
              
            </div>
        </div>
    </div>
  )
}

export default Footer;